<template>
  <div class="flex items-center">
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{params.value}}</router-link>
    <!-- <span>{{params.value}}</span> -->
    <!-- <vs-avatar :src="params.data.avatar" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ params.value }}</router-link> -->
  </div>
</template>

<script>
    export default {
        name: 'InsightProjectLink',
        data() {
          return {
            url: ''
          }
        },
        computed: {
          activeWorkspace() {
            return this.$store.state.space.ActiveSpaceInfo
          }
        },
        created(){
          // return "/apps/space/dashboard/attend/space/:spaceId/id/:userId8"
          this.url = "/apps/space/dashboard/insight-team/space/"+this.activeWorkspace.id+"/project/"+this.params.data.id
        }
    }
</script>
